import * as React from 'react';
import { IRangeSliderProps, NumberRange, RangeSlider } from '@blueprintjs/core';

export interface ICategoryTreeRangeProps extends IRangeSliderProps {
    unit?: string
}

const CategoryTreeRange: React.FunctionComponent<ICategoryTreeRangeProps> = (props) => {
    const [value, setValue] = React.useState<NumberRange>(props.value || [0, 0]);
    const {unit} = props;
    React.useEffect(() => {
        setValue(props.value || [0, 0]);
    }, [props.value]);

    // Main output
    return (
        <>
            <div className="range-slider-value">{`${value[0]} ${unit} - ${value[1]} ${unit}`}</div>
            <RangeSlider
                showTrackFill={true}
                min={props.min}
                max={props.max}
                value={value}
                stepSize={props.stepSize}
                labelStepSize={props.max}
                labelPrecision={0}
                onChange={setValue}
                onRelease={props.onRelease}
            />
        </>

    );
};

CategoryTreeRange.displayName = 'CategoryTreeRange';

export default CategoryTreeRange;
